import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const TheoremsModule = () => (
  <DMModuleSubtopic
    title="Theorems in Trees"
    videos={[]}
    takeaways={[
      
      {text:" If there are any other theorems, don’t forget to learn them."},
      {text:" Prefer to learn the theorems from your class notes."},
      {
        text:"1",
        image:"/dm_58.png"
      },
      {
        text:"2",
        image:"/dm_59.png"
      },
      {
        text:"3",
        image:"/dm_60.png"
      },
      {image:"/dm_61.png"},
      {image:"/dm_62.png"},
      {image:"/dm_63.png"},
        {
        text:"4",
        image:"/dm_64.png"
      },
      {image:"/dm_65.png"},



    ]}
    questions={[
      {
        text: "Prove that a tree with n vertices has n-1 edges."
      },
      {
        text: "Prove that every tree has either one or two centres."
      }
    ]}
    exampleVideos={[]}
  />
);

export default TheoremsModule;
